import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_14yjrsol9b: FaireBrandEntity = {
  token: "b_14yjrsol9b",
  type: "brand",
  name: "Magic Hour",
  avatarUrl:
    "https://cdn.faire.com/fastly/0e66876cc9d152a11bfa39615bf1287214664a249df9ccccbdfc76b419a9f5ed.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c414b9b6474fc3d0c228344506b85d3ff6c6c23bc1b120b54a6401c7bce51ec6.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/0e66876cc9d152a11bfa39615bf1287214664a249df9ccccbdfc76b419a9f5ed.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c414b9b6474fc3d0c228344506b85d3ff6c6c23bc1b120b54a6401c7bce51ec6.jpeg",
  location: "Ojai, CA, USA",
  minimumOrderDollars: 250,
  rating: 4.9,
  reviewCount: 55,
  isInsider: true,
  description:
    "Woman founded & operated by Master Tea Blender Zhena Muzyka, we blend everything to order in the beautiful Ojai Valley. \n\nWe make teas that heal, cleanse, inspire and elevate your daily life, reminding you that you are the magic. our biodynamic, organic, direct-trade botanical potions and exclusive transformational teachings bring you the world's finest mind-body-soul growth on the planet, offering the distillation of the sacred to you. planted, nourished, and harvested on an astrological schedule, aligned with the cyclical harmony of planetary motion, the teas taste like the magic and universal resonance with which they are created. intentional, mindful, and always with respect, our teas sing with magic.\n\n\nShipping Notice: All orders received by 5pm PST on Wednesdays will be shipped by the following Tuesday",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:43.107Z",
    importedBy: "entity-db-cli",
  },
};
